<template>
  <section 
    v-if="shouldRender" 
    class="relative overflow-hidden py-8 md:py-9 lg:py-20 px-4 sm:px-8 lg:px-12 xl:px-[120px]"
    :style="{
      backgroundImage: `url('/landing/bg-report.png')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }"
  >
    <!-- Content Card -->
    <div class="relative z-10 w-full max-w-[707px] mx-auto rounded-2xl p-4 md:p-6 lg:p-10 cta-card">
      <!-- Inner Content -->
      <div class="flex flex-col items-center gap-3 md:gap-4 lg:gap-6 text-center">
        <!-- Title -->
        <h2 
          v-if="ctaTitle" 
          class="cta-title font-nexa text-lg md:text-2xl lg:text-[40px] font-black leading-6 md:leading-8 lg:leading-[60px] text-center"
        >
          {{ ctaTitle }}
        </h2>
        
        <!-- Description -->
        <p 
          v-if="ctaDescription" 
          class="font-inter text-xs md:text-sm lg:text-xl font-normal leading-4 md:leading-5 lg:leading-7 text-center text-white/80"
        >
          {{ ctaDescription }}
        </p>
        
        <!-- Buttons - Always row on all screens -->
        <div class="flex flex-row items-center justify-center gap-3 md:gap-4 mt-1 md:mt-2">
          <!-- Primary Button -->
          <a 
            v-if="primaryLabel" 
            :href="primaryCtaUrl" 
            class="inline-flex items-center justify-center min-w-[100px] h-9 md:h-10 lg:h-12 px-3 md:px-4 lg:px-5 py-2 rounded-full text-xs md:text-sm lg:text-lg font-bold text-white bg-[linear-gradient(98.1deg,#892DDE_3.22%,#4A1878_100%)] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.04)] transition-all duration-200 hover:opacity-90 hover:-translate-y-0.5"
          >
            {{ primaryLabel }}
          </a>
          
          <!-- Secondary Button -->
          <button
            v-if="secondaryLabel"
            type="button"
            class="inline-flex items-center justify-center min-w-[100px] h-9 md:h-10 lg:h-12 px-3 md:px-4 lg:px-5 py-2 rounded-full text-xs md:text-sm lg:text-lg font-bold text-white border border-[#F0F1F2] bg-transparent shadow-[0px_4px_4px_0px_rgba(0,0,0,0.04)] transition-all duration-200 hover:bg-white/10 hover:-translate-y-0.5"
            @click="handleSecondaryClick"
          >
            {{ secondaryLabel }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  primaryCtaUrl: {
    type: String,
    required: true,
  },
  supportEmail: {
    type: String,
    required: true,
  },
  content: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['request-consultation']);

const sectionContent = computed(() => props.content || {});
const ctaTitle = computed(() => sectionContent.value.title || 'Sẵn Sàng Chinh Phục Khách Hàng Với HiCHAT?');
const ctaDescription = computed(() => sectionContent.value.description || 'Hơn 500+ doanh nghiệp đã tin dùng và bứt phá doanh thu. Hãy để chúng tôi đồng hành cùng sự phát triển bền vững của bạn.');
const primaryLabel = computed(() => sectionContent.value.primary_label || 'Đăng ký dùng thử ngay');
const secondaryLabel = computed(() => sectionContent.value.secondary_label || 'Liên hệ kinh doanh');
const shouldRender = computed(() => ctaTitle.value || ctaDescription.value || primaryLabel.value || secondaryLabel.value);

const handleSecondaryClick = () => {
  emit('request-consultation', 'cta-section');
};
</script>

<style scoped>
.cta-card {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.2) 100%);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
}

.cta-title {
  background: linear-gradient(180deg, #FFFFFF 0%, #F4B8FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.font-nexa {
  font-family: '1FTV Nexa', 'Nexa', 'Inter', system-ui, -apple-system, sans-serif;
}
</style>
